//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



export default {
    props: {
        value: [Number, String, Boolean],
        label: String,
        comment: String,
        append: String,
        mask: String,
        type: String,
        rules: Array,
        placeholder: String,
        outlined: Boolean,
        // {
        //     type: Boolean,
        //     default: false
        // },
        disabled: Boolean,
        replaceEngToRu: {
            type: Boolean,
            default: true
        },
        // Ограничения ввода:
        isMoney: Boolean,
        isCyrilic: Boolean,
        isCyrilicIssued: Boolean,
        isCyrilicPlace: Boolean,
        isEngEmail: Boolean,
        error:Boolean,
        manualFocus: Boolean
    },
    computed: {
        fieldValue: {
            get() {
                if (this.isMoney && this.value ) {
                    return this.value.toString().replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1 ');    
                } else {
                    return this.value;
                }
            },
            set( val ) {
                let oldval = val;

                if ( val != this.value ) {
                    // Применяем ограничения ввода
                    val = this.applyInputRestrictions(val);

                    this.$emit('input', val);

                    if (val != oldval) {
                        // перерисовка позволяет видеть в поле ввод с ограничениями
                        this.updateKey++;
                        // autofocus позволяет мобильной клавиатуре оставаться на месте
                        // при перерисовке поля по updateKey
                        this.autofocus = true;
                    } else {
                        this.autofocus = false;
                    }
                }
            }
        },
        appendText() {
            return this.append;
        },
        virtualPlaceholder() {
            if (this.mask) {
                return this.mask.replace(/#/g, '0');
            } else {
                return null;
            }
        },
        isDisabled() {
            return this.disabled;
        }
    },
    data() {
        return {
            updateKey: 0,
            autofocus: false,
            hasError: false,
        }
    },
    methods: {
        applyInputRestrictions( val ) { 
            let oldval = val;
            let key;

            if (this.isMoney) {
                val = val.replace( /\D/g, '' );
            }
            if (this.isEngEmail) {
                val = val.replace( /[^a-zA-Z\-0-9.@]/g, "" );
            }
            if ( this.isCyrilic ) {
                val = val.replace( /[^а-яА-ЯёЁ -]/g, "" );
            } 
            if ( this.isCyrilicIssued ) { 
                val = val.replace( /[^0-9А-яЁё/\\(№\-.,")\s]/g , "" );
            }
            if ( this.isCyrilicPlace ) {
                val = val.replace( /[^0-9А-яЁё("\-.)\s]/g, "" );
            }

            return val;
        },
        onKeydown(e) {
            // У keydown плохая совместимость 
            // с мобильными браузерами на сентябрь 2021
            // в event.key не приходит значение
            this.$emit('keydown', e);
        },
        onBlur(e) {
            this.$emit('blur', e);
        },
    }
    
}
